module.exports = __webpack_public_path__ + "fonts/Inter-700-cyrillic65.fdccea7.woff2";